<template>
  <div class="myInvest">
    <van-nav-bar
      :title="$t('m.tz_span0')"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content">
      <div class="interest_card">
        <div style="display: flex; align-items: center">
          <div class="css">
            <span
              style="
                margin-bottom: 8px;
                color: var(--bg-color);
                font-size: 20px;
                font-weight: bold;
              "
              >{{ yishou }}</span
            >
            <span style="color: #666; font-size: 13px">{{
              $t("m.cw_span2")
            }}</span>
          </div>
          <div class="css">
            <span
              style="
                margin-bottom: 8px;
                color: var(--bg-color);
                font-size: 20px;
                font-weight: bold;
              "
              >{{ daishou }}</span
            >
            <span style="color: #666; font-size: 13px">{{
              $t("m.cw_span3")
            }}</span>
          </div>
        </div>
      </div>

      <div class="detail_card">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('m.gengduo')"
          @load="onLoad"
        >
          <div
            class="card_item"
            v-for="(item, index) in list"
            @click="contract(item.id)"
            :key="index"
          >
            <!-- <router-link :to="{path:'contract/', query:{id:item.id}}"> -->
            <div class="item_title" style="color: #333">{{ item.title }}</div>
            <div class="purchase_code">
              <!-- <span>申购代码：{{item.code}}</span> -->
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <div>
                <div
                  class="purchase_code"
                  style="display: flex; align-items: center"
                >
                  <img
                    src="../../assets/images/new/bianhao.png"
                    style="width: 20px; height: 20px; margin-right: 12px"
                    alt=""
                  />
                  <span>{{ $t("m.tz_span1") }}:{{ item.id }}</span>
                </div>
                <van-count-down :time="item.end_time">
                  <template #default="timeData">
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        padding: 10px 0;
                      "
                    >
                      <img
                        src="../../assets/images/daojishi.png"
                        style="width: 20px; height: 20px; margin-right: 12px"
                        alt=""
                      />
                      <span>到期时间：</span>
                      {{ item.end }}
                      <!--                      <span class="block">{{ timeData.days }}</span>-->
                      <!--                      <span class="colon">d</span>-->
                      <!--                      <span class="block">{{ timeData.hours }}</span>-->
                      <!--                      <span class="colon">h</span>-->
                      <!--                      <span class="block">{{ timeData.minutes }}</span>-->
                      <!--                      <span class="colon">m</span>-->
                      <!--                      <span class="block">{{ timeData.seconds }}</span>-->
                      <!--                      <span class="colon">s</span>-->
                    </div>
                  </template>
                </van-count-down>
                <div
                  class="get_money"
                  style="display: flex; align-items: center"
                >
                  <img
                    src="../../assets/images/new/honghao.png"
                    style="width: 20px; height: 20px; margin-right: 12px"
                    alt=""
                  />
                  <div>
                    {{ $t("m.tz_span3") }}
                    <span style="color: var(--bg-color)">{{
                      item.receive_profit
                    }}</span>
                    元
                  </div>
                </div>
              </div>
              <img
                src="../../assets/images/new/hetong.png"
                style="width: 40px; height: 40px; margin-right: 12px"
                alt=""
              />
            </div>
            <div class="get_money_detail">
              <div>
                <span>{{ $t("m.tz_span4") }}</span>
                <span style="color: var(--bg-color)">{{ item.money }}</span>
              </div>
              <div>
                <span>{{ $t("m.jy_span8") }}</span>
                <span style="color: var(--bg-color)">{{ item.rate }}</span>
              </div>
              <div>
                <span>{{ $t("m.tz_span5") }}</span>
                <span style="color: var(--bg-color)">{{
                  item.zongshouyi
                }}</span>
              </div>
            </div>
            <!-- </router-link> -->
          </div>
        </van-list>
      </div>
    </div>
    <div style="height: 34px"></div>
  </div>
</template>

<script>
import request from "@utils/request";
// import $store from "../../store";
// import { VUE_APP_API_URL } from "@utils/index";
export default {
  name: "",
  data() {
    return {
      list: [],
      page: 0,
      loading: false,
      finished: false,
      refreshing: false,
      yishou: 0,
      daishou: 0
    };
  },
  mounted() {
    // this.$toast.loading({
    //   message: "数据加载中...",
    //   forbidClick: true
    // });
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    async onLoad() {
      this.page = this.page + 1;
      let _this = this;

      request
        .get("/fund/log/list", { page: _this.page }, { login: true })
        .then(res => {
          console.log("余额宝列表数据");
          console.log(res);
          this.yishou = res.data.data.tongji.yishou;
          this.daishou = res.data.data.tongji.daishou;
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }
          for (var i = 0; i < res.data.data.list.length; i++) {
            console.log(res.data.data.list[i]["end_time"]);
            console.log(new Date().getTime() / 1000);
            this.list.push({
              id: res.data.data.list[i]["id"],
              title: res.data.data.list[i]["title"],
              code: res.data.data.list[i]["cday"],
              income: res.data.data.list[i]["income"],
              money: res.data.data.list[i]["money"],
              rate: (
                Number(res.data.data.list[i]["rate"]) +
                Number(res.data.data.list[i]["viprate"] || 0)
              ).toFixed(3),
              clock: res.data.data.list[i]["clock"],
              zongshouyi: Number(res.data.data.list[i]["zongshouyi"]).toFixed(
                3
              ),
              end: res.data.data.list[i]["end"],
              end_time:
                (res.data.data.list[i]["end_time"] -
                  new Date().getTime() / 1000) *
                1000,
              receive_profit: res.data.data.list[i]["profit"]
            });
          }
          this.loading = false;

          if (res.data.data.list.length < 10) {
            this.finished = true;
          }
        })
        .catch(err => {
          console.log(err);

          this.finished = true;
          this.loading = false;
        });
    },
    contract(id) {
      // window.location.href = VUE_APP_API_URL+"/fund/hetong/index?id="+id+"&token="+$store.state.app.token

      this.$router.push({
        path: "/Contract",
        query: {
          id: id
        }
      });
    }
  },
  components: {}
};
</script>

<style scoped lang="less">
.colon {
  display: inline-block;
  margin: 0 4px;
}
.block {
  display: inline-block;
  width: 22px;
  color: var(--bg-color);
  font-size: 12px;
  text-align: center;
}
.myInvest /deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: rgba(0, 0, 0, 0);
}
.myInvest /deep/ .van-nav-bar__title {
  color: #fff;
}
.myInvest /deep/ .van-icon {
  color: #fff;
}
.myInvest {
  height: 100vh;
  background-color: #f6f6f6;
  .content {
    margin-top: -46px;
    padding: 15px 0;
    background-image: url(../../assets/images/bg/8.png);
    background-repeat: no-repeat;
    background-size: 100% 175px;
    .interest_card {
      padding: 15px 0;

      border-radius: 5px;
      margin: 60px 15px 0;
      background-color: #fff;
      box-shadow: 0px 0px 6px #eaeaea;
      .css {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        span {
        }
      }
    }
    .detail_card {
      // background: #dfdfdf;
      margin-top: 10px;
      font-size: 14px;
      .card_item {
        padding: 15px 20px 10px;
        margin-bottom: 10px;
        border-radius: 5px;
        background-color: #fff;
        .item_title {
          padding-bottom: 15px;
          border-bottom: 1px solid #f2f2f2;
        }
        .purchase_code,
        .order_num,
        .get_money {
          line-height: 30px;
          color: #333;
        }
        .get_money_detail {
          display: flex;
          justify-content: space-between;
          color: #333;
          div {
            display: flex;
            flex-direction: column;
            span:nth-child(1) {
              padding: 10px 0;
              font-size: 12px;
              color: #666;
            }
          }
        }
      }
    }
    .loading_finish {
      text-align: center;
      margin-top: 10px;
      font-size: 12px;
      color: #666;
    }
  }
}
</style>
